
import Settings from './src/pages/Settings/Settings.vue'
import SettingsAccount from './src/pages/Settings/Account.vue'
import SettingsEducation from './src/pages/Settings/Education.vue'
import SettingsTheme from './src/pages/Settings/Theme.vue'

export const route = {
  path: '/settings',
  props: true,
  component: Settings,
  name: 'settings',
  meta: {
    title: 'Instellingen',
    requiresAuth: true
  },
  children: [
    {
      path: '',
      alias: 'account',
      meta: {
        title: 'Account instellingen',
      },
      component: SettingsAccount
    },
    {
      name: 'settings-education',
      path: 'education',
      meta: {
        title: 'Opleiding instellingen',
      },
      component: SettingsEducation
    },
    {
      name: 'settings-theme',
      path: 'theme',
      meta: {
        title: 'Website instellingen',
      },
      component: SettingsTheme
    }
  ]
}
